import { useState, useEffect } from "react";
// import { PropallyLpApiFactory } from "src/api/apiFactory";
import { cityList, districtList } from "src/utils/options";

// const fp = PropallyLpApiFactory();

export const useGetCities = (/*prefecture = "東京都"*/) => {
  const [loadingCities, setLoading] = useState<boolean>(false);
  const [cities, setCities] = useState<string[]>([]);

  const getCities = async () => {
    setLoading(true);

    // https://github.com/geolonia/japanese-addresses
    // で提供されている、住所の csv 形式のデータを yaml 形式に変換して保存するスクリプトを用いる自前のAPIを用いたリスト表示
    // 外部APIでは許容プロパティが厳密に決められているため、利用できない
    // const response = await fp.lpV1MasterDataPrefecturesPrefectureNameCitiesGet(prefecture);
    // setCities(response.data);

    setCities(cityList);
    setLoading(false);
  };

  useEffect(() => {
    getCities();
  }, []);

  return {
    loadingCities,
    cities,
  };
};

export const useGetTowns = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [towns, setTowns] = useState<string[]>([]);

  const getTowns = async (/*{ prefecture = "東京都", city }: { prefecture?: string; city: string | null }*/) => {
    setLoading(true);
    setTowns([]);

    // https://github.com/geolonia/japanese-addresses
    // で提供されている、住所の csv 形式のデータを yaml 形式に変換して保存するスクリプトを用いる自前のAPIを用いたリスト表示
    // 外部APIでは許容プロパティが厳密に決められているため、利用できない
    // if (city) {
    //   const response = await fp.lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefecture, city ?? "");
    //   setTowns(response.data);
    // } else {
    //   setTowns([]);
    // }

    // districtList をそのまま設定
    setTowns(districtList);

    setLoading(false);
  };

  return { loading, towns, getTowns, setTowns };
};
